import { useQuery } from "@tanstack/react-query";
import eventClientApi from "@/api-client/event-client";
import { getQueryKey } from "@key.ai/constants";
import { useEventStore } from "@/stores/use-event-store";
import { useSession } from "next-auth/react";
interface MyParticipationResponse {
  status: number;
  message: string;
  data: {
    status: string;
    role: string;
    id: string;
    ticket_id?: string;
    event_reject_reason?: string;
  };
}
interface useUserEventParticipatuonProps {
  eventId: string;
  enabled?: boolean;
  token?: string;
}

export const useUserEventParticipatuon = ({
  eventId,
  enabled = true,
  token
}: useUserEventParticipatuonProps) => {
  const queryKey = getQueryKey("EVENT_USER_PARTICIPATION");

  const { setUserAccess } = useEventStore();

  const fetchMyParticipation = async (): Promise<MyParticipationResponse["data"]> => {
    const { data } = await eventClientApi
      .get(`api/v1/events/${eventId}/participations/me${token ? `?token=${token}` : ""}`)
      .json<MyParticipationResponse>();
    setUserAccess(data?.role);
    return data;
  };
  const { data: user, status: authStatus } = useSession();

  return useQuery<MyParticipationResponse["data"]>({
    queryKey: [queryKey, eventId, token],
    queryFn: fetchMyParticipation,
    enabled: !!eventId && (authStatus === "authenticated" || !!token),
    refetchOnWindowFocus: false,
    refetchOnMount: true
  });
};
